$(function() {
	$.nette.pd.ext('basketItemsRecalc', {
		init: function () {
			this.$snippet = $('#snippet--basketPage');
			if (this.$snippet.length) {
				this.bindSubmit();
			}
		}
	}, {
		bindSubmit: function (settings) {
			var ext = this;
			ext.$snippet.on('change', '#basket .count > input[type="number"]', function (e) {
				clearTimeout(ext.timer);
				ext.timer = setTimeout(function () {
					ext.$snippet.find('[name="recalc"]').trigger('click');
				}, e.isTrigger ? 300 : 0);
			});
		},
		timer: null,
		$snippet: $([])
	});
});
